import React, { useState } from "react";
import Select from "react-select";
import {
    Grid,
    GridColumn as Column,
    GridColumnMenuSort,
    GridColumnMenuFilter,
} from "@progress/kendo-react-grid";
import Switch from "react-switch";
import * as XLSX from 'xlsx';
import ListGroup from 'react-bootstrap/ListGroup';
import { Label, Modal, ModalBody } from "reactstrap";
import KendoNestedGrid from "./KendoNestedGrid.jsx";
import { Button } from "reactstrap";
import StorageSelector from "../custom_modules/inventory/components/StorageSelector.jsx";
import { findPathInArray, Servicecalls, userdetails } from "../custom_functions/Functions.jsx";

const SelectBox = React.lazy(() => import("./SelectBox.jsx"));
class ImportData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [], emptycolumnname: [], storageSample: false, selectedstorage: {
                storagepath: undefined,
                storageid: undefined,
                samplestoragelocationkey: undefined,
                storageItem: undefined
            },
            projectMasterlist: [],
            Material_TypeData: [],
            MaterialCategories: [],
            selectedFieldOptions: [],
            SiteData_List: [],
            SampleCategoris: [],
            SampleTypeList: [],
            SelectedSampleCat: {},
            SelectedType: {}, SelectedMaterialTypejsonParsedData: {}, SelectedMaterialCat: {}, isToggled: true, SelectedSite: {}, SelectedSampleTypejsonParsedData: {}, SelectedEquipmentTypejsonParsedData: {}, SelectedEquipmentCat: {},
            UserGroupData: [
                { usergroupname: "N/A", usergroupcode: -1 },
            ],
            samples: [{ sampleindex: 0, samplequantity: 0, repeatentry: 0, repeatcount: 1, reorderlevel: 0, batchno: "", inventoryname: "" }],
            Columns: props.Columns,
            NestedGrid: props.NestedGrid,
            lstEquipmentType: [],
            lstEquipmentCategory: [],
            lstPeriods: [],
            // selectCalibrationPeriod: {}
        };
        this.aRef = React.createRef(null);
        this.selectioncolumn = [];
        this.handleFieldSelectionChange = this.handleFieldSelectionChange.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onsetimporteddata = this.onsetimporteddata.bind(this);
        this.ELNurl = window.appUrl.ELN;
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateWindowDimensions);
        if (this.props.Columns) {
            this.setState({ columns: this.props.Columns })
        }
        if (this.props.NestedGrid) {
            this.setState({ NestedGrid: this.props.NestedGrid })
        }
        const { Columns, screen, siteDataList } = this.props;
        if (Columns) {
            this.setState({ columns: Columns });
        }
        if (screen === "Material") {
            this.fetchMaterialData();
        } else if (screen === "UserMaster" || screen === "UserGroup") {
            const { User, Usersite, multiusergroups } = sessionStorage;
            const filteredSites = (multiusergroups !== '1')
                ? siteDataList.filter(item => item.sitecode === Number(Usersite))
                : siteDataList;
            this.setState({
                SiteData_List: [{ sitename: "N/A", sitecode: -1 }, ...filteredSites]
            });

        } else if (screen === "Sample") {
            this.fetchSamplCategories();
            this.fetchSampleStorageLocationByKey();
        } else if (screen === "Equipment") {
            Servicecalls("" + this.ELNurl + "/equipment/getEquipmentProps", { nsitecode: Number(sessionStorage.Usersite) },
                this.onGetEquipmentScreenProps.bind(this), (res) => { console.log(res) })
        }

        if (screen === "Sample" || screen === "Material") {
            this.fetchProjectmasters();
        }
    }
    onGetEquipmentScreenProps(res) {
        if (res !== undefined) {
            this.setState({
                lstEquipmentType: [{ sequipmenttypename: "N/A", nequipmenttypecode: -1 }, ...res.lstType],
                lstEquipmentCategory: [{ sequipmentcatname: "N/A", nequipmentcatcode: -1, equipmenttype: { sequipmenttypename: "N/A", nequipmenttypecode: -1 } }, ...res.lstCategories],
                lstPeriods: [{ speriodname: "N/A", nperiodcode: -1 }, ...res.lstPeriods,],
                // selectCalibrationPeriod: res.lstPeriods[0] || {}
            })
        }
    }


    fetchProjectmasters = () => {
        Servicecalls(
            `${this.ELNurl}/Basemaster/getProjectmaster`,
            { lssitemaster: { sitecode: Number(sessionStorage.Usersite) } },
            (res) => {
                this.setState({
                    projectMasterlist: [...res.map((items) => {
                        return { ...items, value: items.projectcode, label: items.projectname }
                    }
                    )],
                });
            },
            (res) => { }
        );
    }

    fetchSamplCategories = () => {
        const siteCode = Number(sessionStorage.Usersite);
        Servicecalls(
            `${this.ELNurl}/SampleType/getSampleType`,
            { nsitecode: siteCode },
            (res) => {
                this.setState({
                    SampleTypeList: [{ ssampletypename: "N/A", nsampletypecode: -1 }, ...res],
                });
            },
            (res) => { }
        );
        this.setState({ SampleCategoris: [{ ssamplecatname: "N/A", nsamplecatcode: -1 }, ...this.props.sampCategories] });
    }

    fetchMaterialData() {
        const siteCode = Number(sessionStorage.Usersite);
        Servicecalls(
            `${this.ELNurl}/materialcategory/getMaterialType`,
            { nsitecode: siteCode },
            (res) => {
                this.setState({
                    Material_TypeData: [{ smaterialtypename: "N/A", nmaterialtypecode: -1 }, ...res],
                });
            },
            (res) => { }
        );

        let cateGories = this.props.matCategories.filter((item) => item.nstatus == 1);

        this.setState({
            MaterialCategories: [{ smaterialcatname: "N/A", nmaterialcatcode: -1 }, ...cateGories],
        });
        this.fetchSampleStorageLocationByKey();
    }

    fetchSampleStorageLocationByKey() {
        Servicecalls(
            `${this.ELNurl}/materialcategory/getAllActiveSampleStorageLocationforimport`,
            { sitekey: Number(sessionStorage.Usersite) },
            (res) => {
                this.setState({ SampleStarageList: res.sampleStorageLocation });

                const sampleStorageLocation = res.sampleStorageLocation.find((item) => item?.samplestoragelocationkey === -1);
                if (sampleStorageLocation) {
                    Servicecalls(
                        `${this.ELNurl}/sampleStorage/getActiveSampleStorageLocationByKey`,
                        sampleStorageLocation,
                        (res) => {
                            this.setState({
                                storageList: res.sampleStorageLocation,
                                treeDataView: JSON.parse(res.selectedSampleStorageVersion.jsonbresult),
                            });
                        },
                        (res) => { }
                    );
                }
            },
            (res) => { }
        );
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }







    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDuplicateobj.isDuplicate && this.state.data.length > 0) {
            let Data = this.state.data.map((items, index) => {
                if (index === 2) {
                    items.selectsecondgrid = true;
                }
                return items
            })
            this.setState({ Data })
        }
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    formatcolumnwidth(index) {
        let width = "250px";

        if (this.state.Columns[index].width !== undefined && this.state.Columns[index].width !== "") {
            width = this.state.width < 1000 ? this.state.Columns[index].width : undefined;
        }

        return width;
    }



    formatcolumn() {
        let columns = [];

        if (this.state.Columns !== undefined && this.state.Columns.length > 0) {
            for (let i = 0; i < this.state.Columns.length; i++) {
                let columnwidth = this.formatcolumnwidth(i);

                if (!this.state.Columns[i].rowselector && this.state.Columns[i].celltype !== "Checkbox"
                    && this.state.Columns[i].celltype !== "Checkboxinventory" && this.state.Columns[i].celltype !== "Button"
                    && this.state.Columns[i].celltype !== "Detailview" && this.state.Columns[i].celltype !== "sharesheetorder"
                    && this.state.Columns[i].celltype !== "copy" && this.state.Columns[i].celltype !== "protocolorderaction"
                    && this.state.Columns[i].celltype !== "protocolaction" && this.state.Columns[i].celltype !== "parseraction"
                    && this.state.Columns[i].celltype !== "orderGridView" && this.state.Columns[i].celltype !== "customStatusColumn"
                    && this.state.Columns[i].celltype !== "dateColumn" && this.state.Columns[i].celltype !== "sheetaction"
                    && this.state.Columns[i].celltype !== "protocolsharedbyaction" && this.state.Columns[i].celltype !== "sheetsharedbyaction" &&
                    this.state.Columns[i].celltype !== "completebuttontemplate" && this.state.Columns[i].celltype !== "orderunsharedbyme" &&
                    this.state.Columns[i].celltype !== "protocolorderunshareaction" && this.state.Columns[i].celltype !== "unshareprotocoltemplate" &&
                    this.state.Columns[i].celltype !== "sharesheettemplate" && this.state.Columns[i].celltype !== "unshareprotocoltemplate"
                    && this.state.Columns[i].celltype !== "sharesheettemplate" && this.state.Columns[i].celltype !== "projectTeamsView" &&
                    // this.state.Columns[i].celltype !== "usergroupviews" &&
                    this.state.Columns[i].celltype !== "ordertransactions" && this.state.Columns[i].celltype !== "inventryhistory"
                    && this.state.Columns[i].celltype !== "MaterialButton") {

                    if (this.state.Columns[i].format === undefined && this.state.Columns[i].header && this.state.Columns[i].header !== "") {
                        columns.push(
                            <Column
                                key={this.state.Columns[i].datatype}
                                field={this.state.Columns[i].datatype}
                                width={columnwidth}
                                className="breakWord60 text-wrap"
                                title={this.state.Columns[i].header}
                            // {...this.columnProps(
                            //     this.state.Columns[i].datatype,
                            //     this.state.orginaldata,
                            //     this.props.primaryKey,
                            //     this.state.Columns[i].header
                            // )}
                            />
                        );
                    }
                }
            }
        }

        return columns;
    }

    isDateFormat = (cell) => {
        if (!cell || !cell.z) return false;

        // Check if cell type is number (dates are stored as numbers in Excel)
        if (cell.t !== 'n') return false;

        const cellFormat = cell.z.toLowerCase();

        // Define date patterns in lowercase to match Excel format codes
        const datePatterns = [
            'dd.mm.yyyy',
            'dd-mm-yyyy',
            'dd/mm/yyyy',
            'yyyy.mm.dd',
            'yyyy-mm-dd',
            'yyyy/mm/dd',
            'dd.mm.yy',
            'dd-mm-yy',
            'dd/mm/yy',
            'mm/dd/yyyy',
            'm/d/yyyy',
            'd/m/yyyy'
        ];

        // Check if any date pattern exists in the cell format
        return datePatterns.some(pattern => cellFormat.includes(pattern));
    }

    onChangefile = (e) => {
        var files = e.target.files, f = files[0];
        if (!files || files.length === 0) return;
        var fi = files[0];
        const allowExtension = ".xls,.xlsx";
        const filename = fi.name;
        const extensionIndex = filename.lastIndexOf('.');
        const extension = filename.substring(extensionIndex + 1).toLowerCase();

        if (!allowExtension.includes(extension)) {
            this.props.alert.error("Please select a Excel file.");
            e.target.value = "";
            this.setState({ selectedfiles: [] });
            return;
        }
        else {
            var reader = new FileReader();
            let _This = this;
            reader.onload = function (e) {
                var data = e.target.result;
                let readedData = XLSX.read(data, {
                    type: 'binary',
                    cellStyles: true,
                    cellNF: true,
                    cellDates: false
                });
                const wsname = readedData.SheetNames[0];
                const ws = readedData.Sheets[wsname];
                const mergedRanges = ws['!merges'] || [];
                const range = XLSX.utils.decode_range(ws['!ref']);
                const dataParse = [];
                for (let R = range.s.r; R <= range.e.r; R++) {
                    const row = [];
                    for (let C = range.s.c; C <= range.e.c; C++) {
                        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                        const cell = ws[cellAddress];
                        if (cell) {
                            if (_This.isDateFormat(cell) && cell.w !== undefined) {
                                row[C] = cell.w;
                            } else {
                                row[C] = cell.v;
                            }
                        } else {
                            row[C] = undefined;
                        }
                    }
                    dataParse.push(row);
                }
                mergedRanges.forEach((range) => {
                    const { s, e } = range;
                    const startRow = s.r;
                    const startCol = s.c;
                    const endRow = e.r;
                    const endCol = e.c;

                    const value = dataParse[startRow][startCol];

                    for (let row = startRow; row <= endRow; row++) {
                        for (let col = startCol; col <= endCol; col++) {
                            if (dataParse[row]?.length > 0 && !dataParse[row][col]) {
                                dataParse[row][col] = value;
                            }
                        }
                    }
                });
                console.log('Parsed Data:', dataParse);
                _This.setState({
                    OriginalExcelData: dataParse,
                    SelectedMaterialCat: {},
                    SelectedType: {}
                });
                _This.onsetimporteddata(dataParse, false);
            };
            reader.readAsBinaryString(f);
        }
    };
    // onChangefile = (e) => {
    //     var files = e.target.files, f = files[0];
    //     if(!files || files.length === 0)return;
    //     var fi = files[0];
    //     const allowExtension = ".xls,.xlsx";
    //     const filename =fi.name;
    //     const extensionIndex = filename.lastIndexOf('.');
    //     const extension = filename.substring(extensionIndex + 1).toLowerCase();
    //     if(!allowExtension.includes(extension)){
    //         this.props.alert.error("Please select a Excel file.");
    //         e.target.value="";
    //         this.setState({selectedfiles:[]});
    //         return;
    //     }
    //     else 
    //     {
    //             var reader = new FileReader();
    //             let _This = this;
    //             reader.onload = function (e) {
    //                 var data = e.target.result;
    //                 let readedData = XLSX.read(data, { type: 'binary' });
    //                 const wsname = readedData.SheetNames[0];
    //                 const ws = readedData.Sheets[wsname];

    //                 // Extract merged cell ranges
    //                 const mergedRanges = ws['!merges'] || [];

    //                 // Parse sheet data with header row
    //                 const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });

    //                 // Handle merged cells by filling empty cells within the merged range
    //                 mergedRanges.forEach((range) => {
    //                     const { s, e } = range;  // 's' is the start cell, 'e' is the end cell of the range

    //                     const startRow = s.r;
    //                     const startCol = s.c;
    //                     const endRow = e.r;
    //                     const endCol = e.c;

    //                     // Get the value of the top-left cell in the merged range
    //                     const value = dataParse[startRow][startCol];

    //                     // Fill all cells in the merged range with the value of the top-left cell
    //                     for (let row = startRow; row <= endRow; row++) {
    //                         for (let col = startCol; col <= endCol; col++) {
    //                             // If the cell is empty, fill it with the merged value
    //                             if (dataParse[row]?.length > 0 && !dataParse[row][col]) {
    //                                 dataParse[row][col] = value;
    //                             }
    //                         }
    //                     }
    //                 });

    //                 console.log(dataParse);  // Output the modified data

    //                 // Update the state with the modified data
    //                 _This.setState({ OriginalExcelData: dataParse, SelectedMaterialCat: {}, SelectedType: {} });
    //                 _This.onsetimporteddata(dataParse, false);
    //             };
    //             reader.readAsBinaryString(f);
    //         }
    // };

    // onChangefile = (e) => {
    //     var files = e.target.files, f = files[0];
    //     var reader = new FileReader();
    //     let _This = this;
    //     reader.onload = function (e) {
    //         var data = e.target.result;
    //         let readedData = XLSX.read(data, { type: 'binary' });
    //         const wsname = readedData.SheetNames[0];
    //         const ws = readedData.Sheets[wsname];
    //         const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
    //         console.log(dataParse);
    //         _This.setState({ OriginalExcelData: dataParse });
    //         _This.onsetimporteddata(dataParse);
    //     };
    //     reader.readAsBinaryString(f);
    // }

    convertToAlpha(number) {

        number = number + 1;

        var baseChar = ("A").charCodeAt(0),
            letters = "";

        do {
            number -= 1;
            letters = String.fromCharCode(baseChar + (number % 26)) + letters;
            number = (number / 26) >> 0; // quick `floor`
        } while (number > 0);

        return letters;
    }

    onsetimporteddata(dataParseobj, istoogle) {
        let dataParse = [];
        console.log(dataParseobj)
        if (dataParseobj[0].length > 0 && dataParseobj[0][0] === undefined && dataParseobj[0][1] !== undefined) {
            dataParseobj.map((item, index) => {
                dataParse.push([]);
                item.map((items) => {
                    if (items !== undefined && items !== "" && typeof (items) === "string") {
                        items = items?.trim()
                    }
                    dataParse[index].push(items)
                })
                return item;
            })
        } else {

            dataParseobj = dataParseobj.map((item, index) => {
                item = item.map((items) => {
                    if (items !== undefined && items !== "" && typeof (items) === "string") {
                        items = items.trim()
                    }
                    return items
                })
                return item;
            })
            dataParse = dataParseobj
        }
        // let getDifference = this.state.columns.filter(object1 => {
        //     return !dataParse[0].some(object2 => {
        //         return object1.header == object2;
        //     });
        // });
        let customizedcolumn = [];
        if (!istoogle && (this.props.screen !== "Material" || this.props.screen !== "Sample")) {

            this.selectioncolumn = [];
        }
        if (this.props.screen === "Material" || this.props.screen === "Sample") {
            let obj = this.state.Columns?.filter(
                (item) => item.header === "Storage Location" || item.header === this.props.t("Inventory.IDS_LBL_ASSIGNEDPROJECT", { param: "", })
            );

            if (obj.length > 0) {
                this.selectioncolumn = [
                    ...this.selectioncolumn,
                    ...obj.map((item) => ({ ...item, importedFileIndex: -1 }))
                ];
            }
        }


        // getDifference = getDifference.filter(items => items.header !== "Site name")
        // if (getDifference.length === 0) {
        //     let originaldatacolumn = dataParse[0];

        //     let customcolum = [];
        //     let originadefaultcomun = this.state.Columns.filter(items => items.datatype !== "sitename")
        //     originadefaultcomun.map((items, index) => {
        //         originaldatacolumn.map((itemsoriginal, indexori) => {
        //             if (items.header === itemsoriginal) {
        //                 items.importedFileIndex = index;
        //                 items.originalHeader = index.items;
        //                 customcolum.push(items);
        //                 this.selectioncolumn.push({ ...items, "key": index, displayheader: items.header, importedFileIndex: index, originalHeader: items.header })
        //             }
        //         })
        //         return items
        //     })
        //     let siteIndex = dataParse[0].indexOf("Site name");
        //     dataParse = dataParse.splice(1, dataParse.length);

        //     if (siteIndex !== -1) {
        //         let filteredData = dataParse.map(row => row.filter((_, i) => i !== siteIndex));
        //         this.onupdategrid(filteredData, customcolum);
        //     } else {
        //         this.onupdategrid(dataParse, customcolum);
        //     }
        //     this.importedcompileddata()
        //     this.aRef.current.value = null;
        // } else {
        const { isToggled } = this.state;
        dataParse = dataParse.filter((items) => items.length > 0);
        const dataLastIndex = dataParse?.reduce((result, items, index) => {
            return items.length > result.LargeValues ? { LargeValues: items.length, index } : result;
        }, { LargeValues: 0, index: -1 });

        const fillMissingIndices = (arr) => {
            let maxIndex = arr.length - 1;
            for (let i = 0; i <= maxIndex; i++) {
                if (arr[i] === undefined) {
                    arr[i] = null;  // You can use '' (empty string) or any other default value
                }
            }
            return arr;
        }
            ;
        customizedcolumn = fillMissingIndices(dataParse[dataLastIndex?.index])?.map((header, i) => ({
            header: this.convertToAlpha(i),
            importedFileIndex: i,
            originalHeader: isToggled ? dataParse[0][i] : "N/A",
        }));

        customizedcolumn.unshift({
            header: "N/A",
            importedFileIndex: -1,
            originalHeader: "N/A"
        })

        if (customizedcolumn.length > 0) {
            this.ColumnUpdateDetails();
            if (isToggled) {
                dataParse = dataParse.splice(1, dataParse.length);
            }
            this.onupdategrid(dataParse, customizedcolumn);
        }
        this.aRef.current.value = null;
        // }
    }

    ColumnUpdateDetails = (DynamicColumn) => {
        let Columns = DynamicColumn !== undefined ? [...this.state.Columns, DynamicColumn] : this.state.Columns;
        Columns.map((items, index) => {
            if (items.ismandatory !== undefined && items.ismandatory && DynamicColumn === undefined) {
                this.selectioncolumn.push({ ...items, displayheader: "N/A", "key": index, importedFileIndex: -1, originalHeader: "N/A" })
            } else if (items.ismandatory !== undefined && items.ismandatory && DynamicColumn !== undefined) {

            }
            return items;
        })
    }

    onupdategrid(originadataobj, customizedcolumn) {
        console.log(originadataobj);
        const filteredArr = originadataobj.filter(arr => arr.length > 0);
        this.setState({
            originalimporteddatas: filteredArr,
            iscolumncustomise: true,
            customizedcolumn: customizedcolumn
        })
    }

    // onCustomiseColumnDatas=()=>{
    //    return  const { selectedFieldOptions, SelectedMaterialTypejsonParsedData } = this.state;
    // }


    renderFieldDesign() {
        const { selectedFieldOptions } = this.state;
        const dynamicFieldsComponents = [];
        if (this.props.screen === "Material" || this.props.screen === "Sample") {
            let SelectedTypeJsondata = this.props.screen === "Sample" ? this.state.SelectedSampleTypejsonParsedData : this.state.SelectedMaterialTypejsonParsedData;
            SelectedTypeJsondata?.sections?.forEach((section) => {
                const activeDynamicFields = section.df?.filter(field => field.used && field.ComboboxType === undefined);
                if (activeDynamicFields?.length) {
                    const dynamicFieldComponents = activeDynamicFields.map((field, index) => {
                        const datatype = field?.datatypevalue?.toLowerCase() || field?.fieldname?.toLowerCase();
                        const isValidField = [
                            "signature",
                            // "multiselect dropdown"
                        ].includes(datatype);
                        if (!isValidField) {
                            return (
                                <div key={index}>
                                    <ListGroup.Item as="li" className="p-0">
                                        <div className="row align-items-center">
                                            <label className="col-sm-5 p-3 mb-0" style={{ left: "23px" }}>
                                                {field.fieldname}
                                            </label>
                                            <div className="col-sm-7 p-3 mb-0">
                                                <Select
                                                    isMulti={datatype === "multiselect dropdown"}
                                                    options={this.state?.customizedcolumn?.map(items => {
                                                        items.value = items.importedFileIndex;
                                                        items.label = this.state.isToggled ? items?.originalHeader : items.header;
                                                        return items;
                                                    })}
                                                    value={selectedFieldOptions[section.uuid + "/" + field.fieldkey]}
                                                    onChange={(selectedOptions, event) => this.handleFieldSelectionChange(selectedOptions, event, datatype)}
                                                    placeholder={datatype}
                                                    name={section.uuid + "/" + field.fieldkey}
                                                />
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                    <dd className="k-line-break"></dd>
                                </div>
                            );
                        }
                        return null;
                    });

                    dynamicFieldsComponents.push(
                        <div key={section.snm}>
                            <div className="row mb-3">
                                <div className="col-5 show-order-content lg-title-bold">
                                    {this.props.t("Logbook.IDS_LBL_DYNAMICCOL")}
                                </div>
                                <div className="col-7 show-order-content lg-title-bold">
                                    {"Section: " + section.snm}
                                </div>
                            </div>
                            <ListGroup as="ol" numbered className="mt-3 lg">
                                {dynamicFieldComponents}
                            </ListGroup>
                        </div>
                    );
                }
            });
        } else if (this.props.screen === "Equipment") {
            let SelectedTypeJsondata = this.state.SelectedEquipmentTypejsonParsedData?.dynamicfields || [];
            if (SelectedTypeJsondata?.length) {
                const dynamicFieldComponents = SelectedTypeJsondata.map((field, index) => {
                    const datatype = field?.datatypevalue?.toLowerCase() || field?.fieldname?.toLowerCase();
                    const isValidField = [
                        "signature",
                        // "multiselect dropdown"
                    ].includes(datatype);
                    if (!isValidField) {
                        return (
                            <div key={index}>
                                <ListGroup.Item as="li" className="p-0">
                                    <div className="row align-items-center">
                                        <label className="col-sm-5 p-3 mb-0" style={{ left: "23px" }}>
                                            {field.fieldname}
                                        </label>
                                        <div className="col-sm-7 p-3 mb-0">
                                            <Select
                                                // isMulti={datatype === "multiselect dropdown"}
                                                options={this.state?.customizedcolumn?.map(items => {
                                                    items.value = items.importedFileIndex;
                                                    items.label = this.state.isToggled ? items?.originalHeader : items.header;
                                                    return items;
                                                })}
                                                value={selectedFieldOptions[field.fieldkey]}
                                                onChange={(selectedOptions, event) => this.handleFieldSelectionChange(selectedOptions, event, datatype)}
                                                placeholder={datatype}
                                                name={field.fieldkey}
                                            />
                                        </div>
                                    </div>
                                </ListGroup.Item>
                                <dd className="k-line-break"></dd>
                            </div>
                        );
                    }
                    return null;
                });

                dynamicFieldsComponents.push(
                    <div >
                        <div className="row mb-3">
                            <div className="col-5 show-order-content lg-title-bold">
                                {this.props.t("Logbook.IDS_LBL_DYNAMICCOL")}
                            </div>
                            {/* <div className="col-7 show-order-content lg-title-bold">
                                {"Section: " + section.snm}
                            </div> */}
                        </div>
                        <ListGroup as="ol" numbered className="mt-3 lg">
                            {dynamicFieldComponents}
                        </ListGroup>
                    </div>
                );
            }
        }


        return dynamicFieldsComponents;
    }

    handleProjectselectionChange = (selectedOptions) => {
        this.setState({ selectedProject: selectedOptions });
        let filtervalues = this.selectioncolumn.some(items => items.header === "Assigned Project");
        if (!filtervalues) {
            let obj = this.state.Columns.find((items) => items.header === "Assigned Project");
            obj.importedFileIndex = -1;
            this.selectioncolumn.push(obj);
        }
    }
    handleFieldSelectionChange(selectedOptionsvalues, { name }, datatype) {
        this.setState(prevState => ({
            selectedFieldOptions: {
                ...prevState.selectedFieldOptions,
                [name]: selectedOptionsvalues
            }
        }));
        // this.selectioncolumnchange(name, undefined, undefined, selectedOptions[0] || selectedOptions)
        let selectedOptions = selectedOptionsvalues[0] || selectedOptionsvalues;
        let objformultiselect = [];
        let filtervalues = this.selectioncolumn.filter(items => items.name === name);
        if (filtervalues.length > 0) {
            if (datatype === "multiselect dropdown" && selectedOptionsvalues?.length > 1) {
                selectedOptionsvalues.map((items) => {
                    objformultiselect.push({
                        displayheader: items.header,
                        importedFileIndex: items.importedFileIndex,
                        originalHeader: items.originalHeader
                    })
                    return items;
                })
            }
            this.selectioncolumn = this.selectioncolumn.map((items) => {
                if (items.name === name) {
                    items = {
                        ...items, key: selectedOptions.key, objformultiselect, displayheader: selectedOptions.header, importedFileIndex: selectedOptions.importedFileIndex, originalHeader: selectedOptions.originalHeader
                    }
                }
                return items
            });
        } else {
            const nameKey = this.props.screen === "Equipment" ? name : name.split("/")[1];
            let obj = this.state.DynamicColumn.find((item) => item.fieldkey === nameKey);
            if (obj) {
                let key = this.state.DynamicColumn.indexOf(obj);

                if (datatype === "multiselect dropdown" && selectedOptionsvalues?.length > 1) {
                    selectedOptionsvalues.map((items) => {
                        objformultiselect.push({
                            key: key,
                            displayheader: items.header,
                            importedFileIndex: items.importedFileIndex,
                            originalHeader: items.originalHeader
                        })
                        return items;
                    })
                }
                this.selectioncolumn.push({
                    ...obj,
                    key: key,
                    objformultiselect,
                    name: name,
                    displayheader: selectedOptions.header,
                    importedFileIndex: selectedOptions.importedFileIndex,
                    originalHeader: selectedOptions.originalHeader
                });
            }
        }
    }

    selectioncolumnchange(key, value, text, object) {
        let filtervalues = this.selectioncolumn.filter(items => items.key === parseInt(key));
        if (object.header !== "N/A") {
            if (filtervalues.length > 0) {
                let isDataPush = false;
                this.selectioncolumn = this.selectioncolumn.map((items) => {
                    if (items.key === parseInt(key)) {
                        items = {
                            ...items, "key": parseInt(key), displayheader: object.header, importedFileIndex: object.importedFileIndex, originalHeader: object.originalHeader
                        }
                        isDataPush = true;
                    }
                    return items
                });
                if (!isDataPush) {
                    let obj = { ...this.state.Columns[parseInt(key)] }
                    this.selectioncolumn.push({ ...obj, "key": parseInt(key), displayheader: object.header, importedFileIndex: object.importedFileIndex, originalHeader: object.originalHeader })

                }
            } else {
                let obj = { ...this.state.Columns[parseInt(key)] }
                this.selectioncolumn.push({ ...obj, "key": parseInt(key), displayheader: object.header, importedFileIndex: object.importedFileIndex, originalHeader: object.originalHeader })
            }
        } else {
            let exists = this.selectioncolumn.find(items => items.key === parseInt(key));
            if (exists !== undefined && Object.keys(exists).length > 0 && exists?.ismandatory) {
                if (exists?.ismandatory) {
                    this.selectioncolumn = this.selectioncolumn?.map((items) => {
                        if (items?.ismandatory && items?.datatype === exists?.datatype) {
                            items.importedFileIndex = -1;
                        }
                        return items;
                    })
                }
            } else {
                let filtervalues = this.selectioncolumn.filter(items => items.key !== parseInt(key));
                this.selectioncolumn = filtervalues;
            }

        }
        if (filtervalues.length === 0) {
            filtervalues = [{ ...this.state.Columns[parseInt(key)] }]
        }
        if ((filtervalues.length > 0 && filtervalues[0].header === "Available Quantity") && (this.props.screen === "Material" || this.props.screen === "Sample")) {
            let Columns;
            let NestedGrid;
            if (object.header !== "N/A") {

                const expiryDateColumn = [{
                    header: this.props.t("Orders.Sheetorders.IDS_LBL_EXPIRY", { param: "" }),
                    datatype: "Expirydate",
                    rowselector: false,
                    locked: false,
                    visible: true,
                    filterable: false,
                    className: "clsModulename",
                    ignoredublicate: true,
                    ignoremandatory: true,
                }];
                if (this.props.screen === "Material") {
                    expiryDateColumn.unshift({
                        header: this.props.t("Orders.Sheetorders.IDS_LBL_INVENTORYNAME"),
                        datatype: "inventoryname",
                        rowselector: false,
                        visible: true,
                        filterable: false,
                        className: "clsModulename",
                        celltype: "materialaction",
                        width: "200px",
                        ignoremandatory: true
                    })
                }
                Columns = [
                    ...this.state.Columns.filter(item => item.datatype !== "Expirydate" && item.datatype !== "inventoryname"),
                    ...expiryDateColumn
                ];
                const StaticColumn = this.state.NestedGrid?.parentcolumns?.filter(item =>
                    ((!item.isDynamicColumn && item.datatype !== "Expirydate") || (!item.isDynamicColumn && item.datatype !== "Expirydate"))
                ) || [];

                StaticColumn.push(...expiryDateColumn);
                const DynamicColumn = this.state.NestedGrid?.parentcolumns?.filter(item => item.isDynamicColumn);
                const AllColumns = [...StaticColumn, ...DynamicColumn];
                NestedGrid = {
                    ...this.state.NestedGrid,
                    parentcolumns: AllColumns
                };
                // Columns = [
                //     ...this.state.Columns.filter(items => items.datatype !== "Expirydate"),
                //     {
                //         header: this.props.t("Orders.Sheetorders.IDS_LBL_EXPIRY", { param: "" }),
                //         datatype: "Expirydate",
                //         rowselector: false,
                //         locked: false,
                //         visible: true,
                //         filterable: false,
                //         className: "clsModulename",
                //         ignoredublicate: true,
                //         ignoremandatory: true,
                //     }
                // ];
                // NestedGrid = {
                //     ...this.state.NestedGrid,
                //     parentcolumns: [
                //         ...this.state.NestedGrid.parentcolumns,
                //         {
                //             header: this.props.t("Orders.Sheetorders.IDS_LBL_EXPIRY", { param: "" }),
                //             datatype: "Expirydate",
                //             rowselector: false,
                //             locked: false,
                //             visible: true,
                //             filterable: false,
                //             className: "clsModulename",
                //             ignoredublicate: true,
                //             ignoremandatory: true,
                //         }
                //     ]
                // };

            } else {
                Columns = this.state.Columns.filter(items => items.datatype !== "Expirydate");
                NestedGrid = {
                    ...this.state.NestedGrid,
                    parentcolumns: this.state.NestedGrid.parentcolumns.filter(items => items.datatype !== "Expirydate")
                }
            }
            this.props.columnUpdateevent(Columns);
            this.setState({ Columns, NestedGrid });
        }
    }

    onCustomiseColumn = (JasonData, key) => {
        let DynamicColumn = [];
        const parsedData = JSON.parse(JasonData || '{}');
        if (Object.keys(parsedData)?.length > 0) {
            if (parsedData?.sections?.length > 0) {
                DynamicColumn = parsedData.sections?.reduce((column, items) => {
                    const SectionColumn = items.df?.filter((fd) => fd.used && fd?.ComboboxType !== "Material" && fd?.ComboboxType !== "Project Master" && fd?.ComboboxType !== "Task Master" && fd?.ComboboxType !== "User Master" && fd?.datatype !== 12)?.map((columnitems, index) => ({
                        ...columnitems,
                        key: index,
                        datatypekey: columnitems.datatype,
                        sections: items.snm,
                        uuid: items.uuid,
                        header: columnitems.fieldname,
                        datatype: `${columnitems.fieldname}/${columnitems.fieldkey}/${items.uuid}`,
                        visible: true,
                        isDynamicColumn: true,
                        ignoremandatory: true,
                    }));
                    column.push(...SectionColumn);
                    return column;
                }, []);
            } else if (parsedData?.dynamicfields?.length > 0) {
                DynamicColumn = parsedData?.dynamicfields.map((columnitems, index) => ({
                    ...columnitems,
                    key: index,
                    datatypekey: columnitems.datatype,
                    // sections: items.snm,
                    // uuid: items.uuid,
                    header: columnitems.fieldname,
                    datatype: `${columnitems.fieldname}/${columnitems.fieldkey}`,
                    visible: true,
                    isDynamicColumn: true,
                    ignoremandatory: true,
                }));
            }

            if (this.props.columnUpdateevent && DynamicColumn?.length > 0) {
                const DynamicColumnrtn = [...this.state.Columns, ...DynamicColumn];
                this.setState(prevState => ({
                    NestedGrid: {
                        ...prevState.NestedGrid,
                        parentcolumns: DynamicColumnrtn,
                    },
                }));
            }
        } else {
            const updateState = (typeData) => {
                this.setState(prevState => ({
                    NestedGrid: {
                        ...prevState.NestedGrid,
                        parentcolumns: prevState.Columns?.filter((items) => !items.isDynamicColumn),
                    },
                    SelectedType: prevState[typeData][0],
                }));
            };
            if (key === "smaterialcatname") {
                updateState('Material_TypeData');
            } else if (key === "ssamplecatname") {
                updateState('SampleTypeList');
            } else if (key === "equipmentcategory") {
                updateState('lstEquipmentType');
            }
        }
        this.setState({ DynamicColumn })
    }


    selectionDynamiccolumnchange = (key, value, text, object) => {
        if (this.props.screen === "Material") {
            if (key === "smaterialcatname") {
                let SelectedType = this.state.Material_TypeData?.find(((items) => items.nmaterialtypecode === object?.nmaterialtypecode))
                this.setState({ SelectedMaterialCat: object, SelectedType, SelectedMaterialTypejsonParsedData: JSON.parse(SelectedType?.jsondata || '{}') });
                let JasonData = SelectedType?.jsondata;
                console.log("kumu")
                this.onCustomiseColumn(JasonData, key);
            }
        } else if (this.props.screen === "Sample") {
            if (key === "ssamplecatname") {
                let SelectedSampleType = this.state.SampleTypeList?.find(((items) => items.nsampletypecode === object?.nsampletypecode))
                this.setState({ SelectedSampleCat: object, SelectedType: SelectedSampleType, SelectedSampleTypejsonParsedData: JSON.parse(SelectedSampleType?.jsondata || '{}') });
                let JasonData = SelectedSampleType?.jsondata;
                this.onCustomiseColumn(JasonData, key);
            }

        } else if (this.props.screen === "UserMaster") {

            if (key === "sitename") {
                if (value !== "-1") {
                    this.setState({ SelectedSite: object });
                    Servicecalls(
                        `${this.ELNurl}/User/GetUserGroupSiteWise`,
                        object,
                        (res) => {
                            console.log("kumu");
                            this.setState({
                                UserGroupData: [
                                    ...(res ? res.filter(items => items.usergroupstatus === this.props.t("Setup.Usermaster.IDS_LBL_ACTIVE")) : [])
                                ]
                            });
                        },
                        (res) => { }
                    );
                } else {
                    this.setState({
                        SelectedSite: {}, UserGroupData: [
                            { usergroupname: "N/A", usergroupcode: -1 },
                        ],
                    });
                }
            }
        } else if (this.props.screen === "UserGroup") {
            if (key === "sitename") {
                this.setState({ SelectedSite: object });
            }

        } else if (this.props.screen === "Equipment") {
            if (key === "equipmentcategory") {
                let SelectedType = this.state.lstEquipmentType?.find(((items) => items.nequipmenttypecode === object?.equipmenttype?.nequipmenttypecode || object?.nequipmenttypecode))
                this.setState({ SelectedEquipmentCat: object, SelectedType, SelectedEquipmentTypejsonParsedData: JSON.parse(SelectedType?.jsondata || '{}') });
                let JasonData = SelectedType?.jsondata;
                console.log("kumu")
                this.onCustomiseColumn(JasonData, key);
            }
        }
    }

    trimValue = (value) => {
        return typeof value === "string" ? value?.trimStart()?.trimEnd() : value;
    };

    assignObjValue = (obj, item, value) => {
        obj[item.datatype] = value;
        return obj;
    };

    assignObjCommonValue = (obj, item, value) => {
        const { datatype, mergedstate } = item;
        if (item.isCombinedType === "boolean") {
            obj[datatype] = this.state[datatype] || false;
        } else if (item.isCombinedType === "merge" && value !== undefined && value !== null && value !== "") {
            obj[datatype] = `${value}-${this.state[`${datatype}_${mergedstate}`]}`;
        }
        return obj;
    };

    assignObjMultiselectValue = (obj, item, itemsobj) => {
        if (item?.objformultiselect?.length === 0) return obj
        item?.objformultiselect?.map((items) => {
            let itemValue = itemsobj[items.importedFileIndex]
            if (obj[item.datatype] === undefined) {
                obj[item.datatype] = this.trimValue(itemValue);
            } else {
                obj[item.datatype] = obj[item.datatype] + "," + this.trimValue(itemValue);
            }
            return items;
        })
        return obj;
    };

    assignObjProjectValue = (obj, item, listvalues) => {
        listvalues?.map((items) => {
            let itemValue = items[item.datatype]
            if (obj[item.datatype] === undefined) {
                obj[item.datatype] = this.trimValue(itemValue);
            } else {
                obj[item.datatype] = obj[item.datatype] + "," + this.trimValue(itemValue);
            }
            return items;
        })
        return obj;
    };


    handleEmptyColumn = (item, emptycolumnname, notaplicableformanitery) => {
        if (item.ignoremandatory === undefined) {
            emptycolumnname.push(item.header);
            notaplicableformanitery = true;
        }
        return notaplicableformanitery;
    };

    importedcompileddata = (e) => {
        let originadataobj = [];
        let emptycolumnname = [];
        let notaplicableformanitery = false;
        this.selectioncolumn = this.selectioncolumn.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t.datatype === value.datatype

            ))
        );
        const MandatoryFields = ["sitename", "StorageLocation", "Expirydate", "Assigned Project", "smaterialtypename", "smaterialcatname", "ssampletypename", "ssamplecatname", "equipmentcategory", "equipmenttype", "CalibrationTimePeriod", "MaintananceTimePeriod"];
        const mantitorycolumn = this.selectioncolumn.filter(
            (items) => !MandatoryFields.includes(items.datatype) && items.ismandatory !== undefined
        );
        let IsmantitoryColunmisFiled = mantitorycolumn.reduce((IsmantitoryColunmisFiled, items) => {
            const isFieldIgnored = items.importedFileIndex === -1;
            if (!IsmantitoryColunmisFiled && !isFieldIgnored) {
                IsmantitoryColunmisFiled = true;
            }
            return IsmantitoryColunmisFiled;
        }, false);
        let skipedRows = "";
        let originadata = IsmantitoryColunmisFiled ? this.state.originalimporteddatas.map((items, index) => {
            let isAllColumnsPresence = true;
            mantitorycolumn.some((item) => {
                const value = items[item.importedFileIndex];
                if ((value === undefined || value === null || value === "" || item.importedFileIndex === -1) && isAllColumnsPresence) {
                    isAllColumnsPresence = false;
                    skipedRows += ` ${index + 1},`;
                    return true;
                }
                return false;
            });
            if (isAllColumnsPresence) {
                return items;
            }
            return null;
        }).filter(item => item !== null) : this.state.originalimporteddatas;


        originadata?.map((items) => {
            let obj = {};
            this.selectioncolumn = this.selectioncolumn.filter((items) => items.datatype);
            items.length > 0 && this.selectioncolumn.some((item) => {
                const itemValue = items[item.importedFileIndex];
                if (item.datatypekey === 11) {
                    obj = this.assignObjMultiselectValue(obj, item, items);
                }
                else if (itemValue !== undefined && itemValue !== "" && item.isCombinedType === undefined) {
                    if (this.props.screen === "Material" && item.fieldkey !== undefined) {
                        obj = this.assignObjValue(obj, item, this.trimValue(itemValue));
                    } else {
                        obj = this.assignObjValue(obj, item, this.trimValue(itemValue));
                    }
                } else if (item.importedFileIndex === -1 || item?.isCombinedType !== undefined) {
                    if (item.datatype === "StorageLocation" && this.state.samples?.length > 0 && this.state?.samples[0]?.storagepath !== undefined) {
                        obj = this.assignObjValue(obj, item, this.state.samples[0]?.storagepath);
                    } else if (
                        ["smaterialtypename", "ssampletypename", "equipmenttype"].includes(item.datatype) &&
                        Object.keys(this.state.SelectedType).length > 0
                    ) {
                        const selectedType = this.state.SelectedType;
                        const typeMapping = {
                            smaterialtypename: selectedType?.smaterialtypename,
                            ssampletypename: selectedType?.ssampletypename,
                            equipmenttype: selectedType?.sequipmenttypename,
                        };

                        const selectedValue = typeMapping[item.datatype];
                        const isEmpty = selectedValue === "N/A";

                        if (item.ignoremandatory === undefined && isEmpty) {
                            notaplicableformanitery = this.handleEmptyColumn(item, emptycolumnname, notaplicableformanitery);
                        } else {
                            obj = this.assignObjValue(obj, item, selectedValue);
                        }
                    }
                    else if (item.datatype === "smaterialcatname" && Object.keys(this.state.SelectedMaterialCat)?.length > 0 && this.state.SelectedMaterialCat?.nmaterialcatcode !== undefined && this.state.SelectedMaterialCat?.nmaterialcatcode !== -1) {
                        obj = this.assignObjValue(obj, item, this.state.SelectedMaterialCat?.smaterialcatname);
                    } else if (item.datatype === "StorageLocation" && this.state.treeDataView?.length > 0 && this.state.treeDataView[0].text === "Default node") {
                        obj = this.assignObjValue(obj, item, `Default ${"->"} ${this.state.treeDataView[0].text}`);
                    } else if (item.datatype === "sitename" && Object.keys(this.state.SelectedSite)?.length > 0) {
                        obj = this.assignObjValue(obj, item, this.state.SelectedSite?.sitename);
                    } else if (item.datatype === "ssamplecatname" && Object.keys(this.state.SelectedSampleCat)?.length > 0) {
                        obj = this.assignObjValue(obj, item, this.state.SelectedSampleCat?.ssamplecatname);
                    } else if (item.datatype === "equipmentcategory" && Object.keys(this.state.SelectedEquipmentCat)?.length > 0 && this.state.SelectedEquipmentCat?.nequipmentcatcode !== undefined && this.state.SelectedEquipmentCat?.nequipmentcatcode !== -1) {
                        obj = this.assignObjValue(obj, item, this.state.SelectedEquipmentCat?.sequipmentcatname);
                    } else if (item.importedFileIndex === -1 && item.header === "Assigned Project") {
                        if (this.state.selectedProject?.length > 0) {
                            obj = this.assignObjProjectValue(obj, item, this.state.selectedProject);
                        } else {
                            obj[item.datatype] = "General";
                        }
                    } else if (this.props.screen === "Equipment" && item.isCombinedType !== undefined) {
                        obj = this.assignObjCommonValue(obj, item, this.trimValue(itemValue));
                    }
                    else {
                        if (item.datatype !== "StorageLocation") {
                            obj = this.assignObjValue(obj, item, null);
                            notaplicableformanitery = this.handleEmptyColumn(item, emptycolumnname, notaplicableformanitery);
                        }
                    }
                    if (item.ignoremandatory === undefined && obj[item.datatype] === undefined) {
                        notaplicableformanitery = this.handleEmptyColumn(item, emptycolumnname, notaplicableformanitery);
                    }
                }
                else {
                    if (item.ignoremandatory === undefined) {
                        notaplicableformanitery = this.handleEmptyColumn(item, emptycolumnname, notaplicableformanitery);
                    }
                }
                if (item.fieldkey !== undefined) {
                    obj[this.props.screen === "Material" ? "Material" : "sample"] = this.state.SelectedType;
                }
                if (emptycolumnname.length > 0 && notaplicableformanitery) {
                    return true;
                }
                return false;
            });
            if (emptycolumnname.length > 0 && notaplicableformanitery) {
            } else {
                originadataobj.push(obj);
            }
            return items;
        });
        if (emptycolumnname.length > 0 && notaplicableformanitery) {
            this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_EMPTYCOLUMN", { column: emptycolumnname[emptycolumnname.length - 1] }));
            // return true;
        }
        if ((emptycolumnname.length > 0 || emptycolumnname.length === 0) && !notaplicableformanitery) {
            this.setState({ emptycolumnname: emptycolumnname });
            const { screen } = this.props;
            const rtnvalues = this.onFormateData(JSON.parse(JSON.stringify(originadataobj)));
            const handleDuplicate = (rtnvalues) => {
                if (rtnvalues?.isDuplicate) {
                    this.setState({
                        isDuplicate: rtnvalues?.isDuplicate,
                        DuplicateRecord: rtnvalues?.optimizedData?.OriginalData,
                        emptycolumnname,
                        data: originadataobj,
                        skipedRows
                    });
                } else {
                    this.setState({ iscolumncustomise: false, selectedFieldOptions: [], data: originadataobj, emptycolumnname, skipedRows, selectedFieldOptions: [] }, () => {
                        this.props.onimporteddats(originadataobj, emptycolumnname, this.state);
                    });

                }
            };

            if (screen === "Material" || screen === "UserMaster" || screen === "UserGroup" || screen === "Sample") {
                handleDuplicate(rtnvalues);
                this.setState({ finalData: rtnvalues });
                console.log(rtnvalues);
            } else {
                handleDuplicate(rtnvalues);
            }
        }

    }

    DuplicateNamecheckevent = (name, itemList, lengthValues, originalDate) => {
        return name.reduce((uniqueNames, item) => {
            if (itemList?.includes(item)) {
                let count = lengthValues + 1;
                return this.DuplicateNamecheckevent([originalDate + "_" + count], itemList, lengthValues + 1, originalDate);
            } else {
                if (!uniqueNames.includes(item)) {
                    uniqueNames.push(item);
                }
            }
            return uniqueNames;
        }, []);
    };


    onFormateData = (originadataobj) => {
        let isDuplicate = false;
        let screenType = this.props.screen;
        let optimizedData = originadataobj.reduce((listofdata, items) => {
            let propertiesToCheck;
            if (screenType === "UserMaster") {
                propertiesToCheck = ['username'];
            } else if (screenType === "Material") {
                propertiesToCheck = ['smaterialname'];
                // propertiesToCheck = ['smaterialname', 'sunitname'];
            } else if (screenType === "UserGroup") {
                propertiesToCheck = ['usergroupname'];
            } else if (screenType === "Sample") {
                propertiesToCheck = ['samplename'];
                // propertiesToCheck = ['ssamplecatname', 'ssampletypename', 'sunitname'];
            } else if (screenType === "Equipment") {
                propertiesToCheck = ['sequipmentname'];
            }
            propertiesToCheck?.forEach(prop => {
                if (items[prop] !== undefined && !listofdata[prop]?.includes(items[prop])) {
                    listofdata[prop]?.push(items[prop]);
                    // uniqName.push()
                } else if (items[prop] !== undefined && listofdata[prop]?.includes(items[prop])) {
                    let lengthValues = listofdata[prop]?.filter(item => item === items[prop])?.length;
                    let newName = this.DuplicateNamecheckevent([items[prop] + "_" + lengthValues], listofdata[prop], lengthValues, items[prop]);
                    items[prop] = newName[0];
                    listofdata[prop]?.push(items[prop]);
                    if (!isDuplicate) {
                        isDuplicate = true;
                    }
                }
            });
            listofdata.OriginalData?.push(items);

            return listofdata;
        }, {
            OriginalData: [],
            username: [],
            smaterialname: [],
            sunitname: [],
            usergroupname: [],
            userrole: [],
            samplename: [],
            sequipmentname: []
            // uniqName: []
        });

        return {
            isDuplicate: isDuplicate,
            optimizedData
        };
    }

    closeModel = (e) => {
        e.preventDefault();
        // this.setState({ iscolumncustomise: false });
        this.setState(prevState => ({
            NestedGrid: {
                ...prevState.NestedGrid,
                parentcolumns: this.state.Columns?.filter((items) => items.isDynamicColumn === undefined)
            },
            iscolumncustomise: false, selectedFieldOptions: [],
            selectedProject: [], skipedRows: ""
        }));
        if (this.props.screen === "Equipment") {
            const stateUpdates = {};
            this.state.Columns?.forEach(({ datatype }) => {
                if (
                    datatype === "EquipmentUsed" ||
                    datatype === "Calibrationrequired" ||
                    datatype === "Maintenancerequired"
                ) {
                    stateUpdates[datatype] = false;
                }
            });
            this.setState({
                ...stateUpdates,
                Columns: this.props.Columns
            });
        }

    }

    shouldShowSelectBox = (datatype) => {
        return !(datatype === "StorageLocation" || datatype === "equipmentcategory" || datatype === "equipmenttype" || datatype === "smaterialtypename" || datatype === "smaterialcatname" || datatype === "sitename" || datatype === "ssamplecatname" || datatype === "ssampletypename" || datatype === "projectname"
            || datatype === "EquipmentUsed" || datatype === "Calibrationrequired" || datatype === "Maintenancerequired" || datatype === "CalibrationTimePeriod" || datatype === "MaintananceTimePeriod"
        );
    }

    shouldShowDynamicSelectBox = (datatype, screen) => {
        return (
            ((datatype === "smaterialtypename" || datatype === "smaterialcatname") && screen === "Material") || ((datatype === "equipmentcategory" || datatype === "equipmenttype") && screen === "Equipment") ||
            ((this.props.screen === "UserMaster" && datatype === "sitename") || (this.props.screen === "UserGroup" && datatype === "sitename")) ||
            ((datatype === "ssamplecatname" || datatype === "ssampletypename") && screen === "Sample")
        );
    }

    allowMultipleSelect = (datatype) => {
        return ((datatype === "projectname") && (this.props.screen === "Material" || this.props.screen === "Sample"));
    }

    toEnableCustomisedDesing = (datatype) => {
        return ((datatype === "EquipmentUsed" || datatype === "Calibrationrequired" || datatype === "Maintenancerequired" || datatype === "CalibrationTimePeriod" || datatype === "MaintananceTimePeriod"));
    }

    onUpdateRequired = (datatype) => {
        this.setState({
            [datatype]: !this.state[datatype]
        }, () => {
            let Columns = [...this.state.Columns];
            let NestedGrid = { ...this.state.NestedGrid };
            const parentcolumnsIndex = Columns.findIndex(
                (item) => item.datatype === datatype
            );
            if (this.state[datatype]) {
                const childColumns =
                    this.props.UpdatedColumns?.filter(
                        (item) =>
                            item.parentDatatype !== undefined &&
                            item.parentDatatype === datatype
                    ) || [];

                if (parentcolumnsIndex !== -1 && childColumns.length > 0) {
                    Columns.splice(parentcolumnsIndex + 1, 0, ...childColumns);
                    if (NestedGrid?.parentcolumns?.findIndex(item => item.parentDatatype === datatype) === -1) {
                        NestedGrid.parentcolumns.push(...childColumns);
                    }
                    Columns?.map((items, index) => {
                        if (items.ismandatory && this.selectioncolumn.find(item => item.datatype === items.datatype) === undefined && items.parentDatatype === datatype) {
                            this.selectioncolumn.push({ ...items, displayheader: "N/A", "key": index, importedFileIndex: -1, originalHeader: "N/A" })
                        }
                    })
                }
                Columns?.map((items, index) => {
                    if (this.selectioncolumn.find(item => item.datatype === datatype) === undefined && items.datatype === datatype) {
                        this.selectioncolumn.push({ ...items, displayheader: "N/A", "key": index, importedFileIndex: -1, originalHeader: "N/A", isChecked: true })
                    }
                })
            } else {
                Columns = Columns.filter(
                    (item) => item.parentDatatype !== datatype
                );
                this.selectioncolumn = this.selectioncolumn.filter((items) => items.parentDatatype !== datatype && items.datatype !== datatype);
                NestedGrid.parentcolumns = NestedGrid.parentcolumns.filter((item) => item.parentDatatype !== datatype);
            }
            this.setState({ Columns, NestedGrid });
        })
    }

    customisedDesign = (item, Datasource, ValueMember, DisplayMember, index) => {
        const { datatype, Type } = item;
        const isChecked = !!this.state[datatype];
        const toggleState = () => {
            this.setState(prev => ({
                [datatype]: !prev[datatype]
            }));
        };
        if (Type === "Toggle") {
            return (
                <div>
                    <label
                        className="switch-container"
                        style={{
                            position: "relative",
                            float: "right",
                            top: "20px",
                            left: "14px"
                        }}
                    >
                        <Switch
                            onChange={toggleState}
                            checked={isChecked}
                            width={40}
                            height={20}
                            handleDiameter={16}
                        />
                    </label>
                </div>
            );
        } else if (Type === "Check") {
            return (
                <div style={{ position: "relative", left: "43px", top: "16px" }}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`check-${datatype}`}
                        checked={isChecked}
                        onChange={() => this.onUpdateRequired(datatype)}
                    />
                </div>
            );
        } else if (Type === "CustomisedSelectBox") {
            return (
                <>
                    <div className="col-sm-4 p-3">
                        <SelectBox
                            Keyvalue={index}
                            selClsname="form-control"
                            Datasource={Datasource}
                            ValueMember={ValueMember}
                            DisplayMember={DisplayMember}
                            valuechange={this.selectioncolumnchange.bind(this)}
                        />
                    </div>
                    <div className="col-sm-3 p-3">
                        <SelectBox
                            Keyvalue={index}
                            selClsname="form-control"
                            Datasource={this.state.lstPeriods}
                            value={this.state.lstPeriods?.filter((items) => items.speriodname === this.state[`${datatype}_selectCalibrationPeriod`])}
                            ValueMember="nperiodcode"
                            DisplayMember="speriodname"
                            valuechange={(key, value, text, object) => {
                                this.onCustomSelectChange(
                                    datatype,
                                    text
                                );
                            }}
                        />
                    </div>
                </>


            )
        }
        return null;
    };

    onCustomSelectChange = (datatype, object) => {
        this.setState({ [`${datatype}_selectCalibrationPeriod`]: object });
    }



    render() {
        let customstlye = { "display": "flex", "align-items": "center" };
        return (<div>
            {this.state.iscolumncustomise && (
                <Modal
                    isOpen={this.state.iscolumncustomise}
                    className={"modal-lg"}
                    onOpened={() => {
                        console.log("Modal Opened");
                    }}
                >
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">
                            Import data
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={this.closeModel.bind(this)}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <ModalBody>
                        <div style={{ height: "calc(100vh - 200px)", overflowY: "auto", overflowX: "hidden", padding: "0 8px" }}>
                            <div className="row">
                                <div className="col-4 show-order-content lg-title-bold">
                                    {this.props.t("Logbook.IDS_LBL_DEFAULTCOL")}
                                </div>
                                <div className="col-4 show-order-content lg-title-bold">
                                    Imported Columns
                                </div>
                                <div className="col-4 show-order-content lg-title-bold">
                                    <div>Excel Headers:</div>
                                    <label
                                        className="switch-container"
                                        style={{
                                            position: "relative",
                                            float: "right",
                                            right: "62px",
                                            bottom: "21px",
                                        }}
                                    >
                                        <Switch
                                            onChange={() =>
                                                this.setState({ isToggled: !this.state.isToggled }, () =>
                                                    this.onsetimporteddata(this.state.OriginalExcelData, true)
                                                )
                                            }
                                            checked={this.state.isToggled}
                                            width={40}
                                            height={20}
                                            handleDiameter={16}
                                        />
                                    </label>
                                </div>
                            </div>
                            <ListGroup as="ol" numbered>
                                {this.state.Columns &&
                                    this.state.Columns.map((item, index) => {
                                        if (!item.header || item.header === "") return null;
                                        const { datatype, header, ismandatory, readOnly, Type } = item;
                                        const getSelectBoxProps = () => {
                                            if (datatype === "smaterialtypename") {
                                                return {
                                                    Datasource: this.state.Material_TypeData,
                                                    ValueMember: "nmaterialtypecode",
                                                    DisplayMember: "smaterialtypename",
                                                };
                                            } else if (datatype === "smaterialcatname") {
                                                return {
                                                    Datasource: this.state.MaterialCategories,
                                                    ValueMember: "nmaterialcatcode",
                                                    DisplayMember: "smaterialcatname",
                                                };
                                            } else if (datatype === "ssampletypename") {
                                                return {
                                                    Datasource: this.state.SampleTypeList,
                                                    ValueMember: "nsampletypecode",
                                                    DisplayMember: "ssampletypename",
                                                };
                                            }
                                            else if (datatype === "ssamplecatname") {
                                                return {
                                                    Datasource: this.state.SampleCategoris,
                                                    ValueMember: "nsamplecatcode",
                                                    DisplayMember: "ssamplecatname",
                                                };
                                            }
                                            else if (((this.props.screen === "UserMaster" && datatype === "sitename") || (this.props.screen === "UserGroup" && datatype === "sitename"))) {
                                                return {
                                                    Datasource: this.state.SiteData_List,
                                                    ValueMember: "sitecode",
                                                    DisplayMember: "sitename",
                                                };
                                            } else if (datatype === "equipmentcategory") {
                                                return {
                                                    Datasource: this.state.lstEquipmentCategory,
                                                    ValueMember: "nequipmentcatcode",
                                                    DisplayMember: "sequipmentcatname",
                                                }
                                            }
                                            else if (datatype === "equipmenttype") {
                                                return {
                                                    Datasource: this.state.lstEquipmentType,
                                                    ValueMember: "nequipmenttypecode",
                                                    DisplayMember: "sequipmenttypename",
                                                }
                                            }
                                            else {
                                                return {
                                                    Datasource: this.state.customizedcolumn,
                                                    ValueMember: "header",
                                                    DisplayMember: this.state.isToggled ? "originalHeader" : "header",
                                                };
                                            }
                                        };
                                        const { Datasource, ValueMember, DisplayMember } = getSelectBoxProps();
                                        return (
                                            <div key={index}>
                                                <ListGroup.Item as="li">
                                                    <div className="row">
                                                        <label
                                                            className={ismandatory ? "col-sm-5 p-3 required" : "col-sm-5 p-3"}
                                                        >
                                                            {header}
                                                        </label>
                                                        {
                                                            this.shouldShowSelectBox(datatype, this.props.screen) ? (
                                                                <div className="col-sm-7 p-3">
                                                                    <SelectBox
                                                                        Keyvalue={index}
                                                                        selClsname="form-control"
                                                                        Datasource={Datasource}
                                                                        ValueMember={ValueMember}
                                                                        DisplayMember={DisplayMember}
                                                                        valuechange={this.selectioncolumnchange.bind(this)}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                this.shouldShowDynamicSelectBox(datatype, this.props.screen) ? (
                                                                    <div className="col-sm-7 p-3">
                                                                        <SelectBox
                                                                            Keyvalue={datatype}
                                                                            selClsname="form-control"
                                                                            Datasource={Datasource}
                                                                            ValueMember={ValueMember}
                                                                            DisplayMember={DisplayMember}
                                                                            valuechange={this.selectionDynamiccolumnchange.bind(this)}
                                                                            optiondisabled={datatype === "smaterialtypename" || datatype === "ssampletypename" ? true : false}
                                                                            readOnly={readOnly !== undefined && readOnly ? true : false}
                                                                            value={datatype === "smaterialtypename" || datatype === "ssampletypename" || datatype === "equipmenttype" ? this.state.SelectedType : {}}
                                                                        />
                                                                    </div>
                                                                ) : this.allowMultipleSelect(datatype) ? (
                                                                    <div className="col-sm-7 p-3">
                                                                        <Select
                                                                            isMulti={true}
                                                                            options={this.state.projectMasterlist}
                                                                            value={this.state.selectedProject}
                                                                            onChange={this.handleProjectselectionChange.bind(this)}
                                                                            placeholder={header}
                                                                            name={datatype}
                                                                        />
                                                                    </div>
                                                                ) :
                                                                    this.toEnableCustomisedDesing(datatype) ? (
                                                                        <>
                                                                            {this.customisedDesign(item, Datasource, ValueMember, DisplayMember, index)}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div className="col-sm-3 p-3">
                                                                                <Button
                                                                                    className="btn-user 7 btn-primary-blue"
                                                                                    style={customstlye}
                                                                                    onClick={() => {
                                                                                        this.setState({ storageSample: true });
                                                                                    }}
                                                                                >
                                                                                    {"Add Storage"}
                                                                                </Button>
                                                                            </div>
                                                                            {this.state.samples?.length > 0 && this.state.samples[0].storagepath && (
                                                                                <label className="col-sm-4 p-3">{this.state.samples[0].storagepath}</label>
                                                                            )}
                                                                        </>
                                                                    )
                                                            )}
                                                    </div>
                                                </ListGroup.Item>
                                                <dd className="k-line-break"></dd>
                                            </div>
                                        );
                                    })}
                            </ListGroup>

                            {((Object.keys(this.state.SelectedMaterialTypejsonParsedData).length > 0) || (Object.keys(this.state.SelectedSampleTypejsonParsedData).length > 0) || ((Object.keys(this.state.SelectedEquipmentTypejsonParsedData).length > 0))) &&
                                this.renderFieldDesign()}
                        </div>
                    </ModalBody>

                    <div id="UserMasterADD-modal-footer" className="modal-footer">
                        <button
                            type="button"
                            id="idSaveSheetAs"
                            className="btn btn-user btn-primary-blue"
                            onClick={this.importedcompileddata.bind(this)}
                        >
                            Ok
                        </button>
                        <button
                            type="button"
                            className="btn modalbluebtn button"
                            onClick={this.closeModel.bind(this)}
                        >
                            {this.props.t("Header.IDS_LBL_CLOSE", { param: "" })}
                        </button>
                    </div>
                </Modal>
            )}

            <ul className="list-inline">
                <li className="list-inline-item">
                    <div className="align-items-center mb-2 customUploadFile">
                        <span className="btn btn-file file-upload-btn">
                            <i className="fas fa-file-upload mr-2" />
                            {this.props.t("Setup.Usergroup.IDS_LBL_SELECTFILE", { param: "" })}
                            <input
                                ref={this.aRef}
                                className="btn-file"
                                type="file"
                                name="file"
                                onChange={this.onChangefile}
                                // accept={[".xls", ".xlsx"]}
                                accept=".xls,.xlsx"
                            />
                        </span>
                        <label className="uploaded-file ml-1">
                            {this.state.selectedfiles !== undefined && this.state.selectedfiles.length > 0 ? this.state.selectedfiles[0].name : ""}
                        </label>
                    </div>
                </li>
                <li>
                    <div className="align-items-center mb-2 customUploadFile">
                        <Button className="btn btn-primary-blue" id="id-equipment-addpopup" role="button" style={{ position: 'relative', bottom: '35px', left: '107px' }}
                            onClick={() => {
                                this.setState({
                                    data: this.state.data?.reverse()
                                })
                            }}
                        >
                            <i className="fa fa-sort"></i> Sort
                        </Button>
                        {/* <button onClick={() => this.handleSort('default')}>
                            <i className="fa fa-sort"></i> Sort
                        </button> */}
                    </div>
                </li>
            </ul>
            {
                this.state.NestedGrid !== undefined ?
                    <div style={{ overflow: "auto" }}>
                        <KendoNestedGrid griddetails={{ ...this.state.NestedGrid, GridParentData: this.state.data }} showChild={false} />
                    </div>
                    :
                    <Grid
                        data={this.state.data}
                        // cellRender={this.cellRender}
                        style={{ height: "65vh", }}
                        selectedField="selectsecondgrid"


                    >
                        {this.formatcolumn()}
                    </Grid>
            }

            {
                this.state.storageSample && <StorageSelector
                    selectedRecord={this.state.selectedstorage}
                    onSetStorageLocationOnInvnt={(selectedStorage, storageitem, treeDataView, activeindex) => {
                        let path = findPathInArray(treeDataView, storageitem.id, selectedStorage.samplestoragelocationname);
                        let newData = this.state.samples.map(item => {
                            if (item.sampleindex === activeindex) {
                                item.storagepath = path;
                                item.storageid = storageitem.id;
                                item.samplestoragelocationkey = selectedStorage;
                                item.storageItem = storageitem;
                            }
                            return item;
                        });

                        let filtervalues = this.selectioncolumn.filter(items => items.header === "Storage Location");
                        if (filtervalues.length === 0) {
                            let obj = this.state.columns.find((item) => item.header === "Storage Location");
                            if (obj) {
                                this.selectioncolumn.push({
                                    ...obj,
                                    importedFileIndex: -1
                                });
                            }
                        }

                        this.setState({ samples: newData, storageSample: false });
                        if (this.props.UpdateInventoryData !== undefined) {
                            this.props.UpdateInventoryData(newData);
                        }
                        console.log("kumu")
                    }}

                    onHandleClose={() => { this.setState({ storageSample: false }) }} activeindex={0} />
            }
            <Modal centered isOpen={this.state.isDuplicate}>
                <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                        {this.props.t("Templates.Protocoltemplates.IDS_LBL_IMPORTCONFORMALERT")}
                    </h5>
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => { this.setState({ isDuplicate: false }) }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <ModalBody>
                    <div className="login-form">
                        <p>
                            {this.props.t("Templates.Protocoltemplates.IDS_LBL_IMPORTDUBLICATE")}
                        </p>
                    </div>
                </ModalBody>
                <div id="UserMasterADD-modal-footer" className="modal-footer">
                    <button
                        type="button"
                        id="idSaveSheetAs"
                        className="btn btn-user btn-primary-blue"
                        onClick={() => {
                            this.setState({ isDuplicate: false, iscolumncustomise: false, selectedFieldOptions: [], data: this.state.DuplicateRecord })
                            this.props.onimporteddats(this.state.DuplicateRecord, this.state.emptycolumnname, this.state);
                        }}
                    >
                        {this.props.t("Setup.Usermaster.IDS_LBL_YES")}
                    </button>

                    <button
                        type="button"
                        id="idSaveSheetAs"
                        className="btn btn-user btn-primary-blue"
                        onClick={() => {
                            let screenType = this.props.screen;
                            let propertiesToCheck;
                            if (screenType === "UserMaster") {
                                propertiesToCheck = ['username', 'userrole'];
                            } else if (screenType === "Material") {
                                propertiesToCheck = ['smaterialname', 'sunitname'];
                            } else if (screenType === "UserGroup") {
                                propertiesToCheck = ['usergroupname'];
                            } else if (screenType === "Sample") {
                                propertiesToCheck = ['ssamplecatname', 'ssampletypename'];
                            } else if (screenType === "Equipment") {
                                propertiesToCheck = ['sequipmentname'];
                            }
                            let filteredData = this.state.data.filter((item, index, self) => {
                                const identifier = propertiesToCheck.map(prop => item[prop]).join('_');
                                return index === self.findIndex((t) => {
                                    return propertiesToCheck.map(prop => t[prop]).join('_') === identifier;
                                });
                            });
                            this.setState({ isDuplicate: false, iscolumncustomise: false, selectedFieldOptions: [], data: filteredData, DuplicateRecord: filteredData })
                            this.props.onimporteddats(filteredData, this.state.emptycolumnname, this.state);
                        }}
                    >
                        {this.props.t("Orders.Protocolorders.IDS_LBL_SKIP")}
                    </button>

                    <button
                        type="button"
                        className="btn modalbluebtn button"
                        onClick={() => {
                            this.setState({ isDuplicate: false, data: [], DuplicateRecord: [] })
                            this.props.onimporteddats([], this.state.emptycolumnname, this.state);
                        }}
                    >
                        {this.props.t("Setup.Usermaster.IDS_LBL_NO", {
                            param: "",
                        })}
                    </button>
                </div>
            </Modal>
        </div >)
    }
}





export default ImportData;